/** CSS class suffix for session end-reason pills (see styles.css). */
export type ActivityStatusPillVariant = 'active' | 'signedOut' | 'timedOut' | 'replaced';

export function getActivityStatusPillVariant(endReason: string | null | undefined): ActivityStatusPillVariant {
  if (!endReason) return 'active';
  switch (endReason.toLowerCase()) {
    case 'logout':
      return 'signedOut';
    case 'expired':
      return 'timedOut';
    case 'superseded':
      return 'replaced';
    default:
      return 'timedOut';
  }
}

export function getActivityStatusPillClassName(endReason: string | null | undefined): string {
  const variant = getActivityStatusPillVariant(endReason);
  return `activity-status-pill activity-status-pill--${variant}`;
}
